// extracted by mini-css-extract-plugin
module.exports = {"SaasTool":"SaasTool_SaasTool__UrCXD","SaasToolParent":"SaasTool_SaasToolParent__2VXvt","rounded":"SaasTool_rounded__3PdZb"};